import { hexToRGB } from '@repo-level/core-front';
import styled from 'styled-components/macro';

export interface ScProgressBarProps {
  $progress: string;
  $color: string;
}

export const ScProgressBar = styled.div<ScProgressBarProps>`
  width: 100%;

  .progress-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 8px;
    padding: 1px;
    border-radius: 360px;
    background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
  }

  .progress-bar-line {
    display: flex;
    position: relative;
    width: ${({ $progress }) => $progress};
    height: 100%;
    border-radius: inherit;
    background: ${({ $color }) => $color};
  }

  .dots {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 4px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 8px;
    padding: 0 2px 0 2px;
    z-index: 10;
  }

  .dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.grayColor7};
  }

  .dot.active {
    background-color: ${({ theme }) => theme.whiteColor};
  }
`;
